import * as React from "react";
import { useForm } from "react-hook-form";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

interface FormInputs {
  query: string;
}

interface Props {
  setQuery: (query: string) => void;
  query?: string;
  reset: () => void;
  isFetching: boolean;
}

export const SnapshotCollectionsOutcomesListInput: React.FC<Props> = ({ isFetching, query, setQuery, reset }) => {
  const methods = useForm<FormInputs>();

  const handleReset = () => {
    reset();
    methods.reset();
  };

  const onSearch = async (payload: FormInputs) => {
    if (!payload.query) {
      return;
    }
    setQuery(payload.query);
  };

  return (
    <form onSubmit={methods.handleSubmit(onSearch)} className="mb-4 flex flex-1 items-center">
      <div className="relative flex-grow">
        <input
          type="text"
          {...methods.register("query")}
          placeholder="Search in SnapShot"
          className="w-full rounded-md border border-gray-300 py-2 pl-10 pr-4 focus:border-blue-500 focus:outline-none"
        />
        <MagnifyingGlassIcon className="absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-gray-400" />
      </div>
      <button
        type="submit"
        disabled={!!query && isFetching}
        onClick={methods.handleSubmit(onSearch)}
        className="ml-2 rounded-md bg-desert-sand-700 px-4 py-2 text-white hover:bg-desert-sand-900 focus:outline-none focus:ring-2 focus:ring-blue-900 focus:ring-opacity-50"
      >
        {query && isFetching ? "Searching..." : "Search"}
      </button>
      {query && (
        <button
          type="button"
          onClick={handleReset}
          className="ml-2 rounded-md bg-gray-300 px-4 py-2 text-gray-700 hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-opacity-50"
        >
          Clear
        </button>
      )}
    </form>
  );
};
